import client from "./client";

export const onboardingApi = {
  generateDashboard: (description: string) =>
    client.post("/onboarding/generate-dashboard", { description }),
};
